export class FlpPermissions {
  constructor({
    flowId,
    hasViewPermission,
    hasEditPermission,
    hasDeletePermission,
    fieldLevelPermissionReasons
  }) {
    this.flowId = flowId;
    this.hasViewPermission = hasViewPermission;
    this.hasEditPermission = hasEditPermission;
    this.hasDeletePermission = hasDeletePermission;
    this.fieldLevelPermissionReasons = fieldLevelPermissionReasons;
  }
  getHasViewPermission() {
    return this.hasViewPermission;
  }

  // Might need to be updated for V2
  isDowngradeScenario() {
    return this.hasViewPermission && !this.hasEditPermission && this.hasDeletePermission;
  }
  hasAccess(feature) {
    switch (feature) {
      case 'EXPORT':
      case 'TEST':
        return this.hasViewPermission;
      case 'ASSIGN_TEAM':
      case 'CLONE':
      case 'COMMENT':
      case 'DISABLE':
      case 'EDIT_ACTIONS':
      case 'EDIT_DESCRIPTION':
      case 'EDIT_ENROLLMENT':
      case 'EDIT_GOAL':
      case 'EDIT_REENROLLMENT':
      case 'EDIT_SETTINGS':
      case 'ENABLE':
      case 'MANUAL_ENROLLMENT':
      case 'MOVE':
      case 'RESTORE':
        return this.hasEditPermission;
      case 'DELETE':
        return this.hasDeletePermission;
      default:
        return false;
    }
  }
  get flpRejectionReasons() {
    return this.fieldLevelPermissionReasons;
  }
}